import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { TelephonyProvider } from '@projects/shared/src/app/providers/telephony/telephony.provider';
import { TelephonyStateService } from '@projects/shared/src/app/providers/telephony/telephony.state.service';
import { ToastService } from '@projects/shared/src/app/services/toast/toast.service';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CallMonitorService implements OnDestroy {
  subscription: Subscription = new Subscription();
  constructor(private httpClient: HttpClient, private telephony: TelephonyProvider) {
    this.subscription.add(
      this.telephony.voice.events.subscribe((event) => {
        switch (event.type) {
          case 'Monitor':
            switch (event.name) {
              case 'init':
                this.isLoading = true;
                this.activeMonitoringSid = event.data;
                this.isMuted = false;
                this.isOperationDisabled = true;
                break;
              case 'accept':
                this.activeMonitoringSid = event.data;
                this.isMonitoring = true;
                this.isLoading = false;
                this.isMuted = false;
                setTimeout(() => {
                  this.isOperationDisabled = false;
                }, 3000);
                break;
              case 'disconnect':
                this.activeMonitoringSid = '';
                this.isMonitoring = false;
                this.isLoading = false;
                this.isMuted = false;
                this.monitorType = 'observe';
                this.tempTypeValue = this.monitorType;
                this.call = {};
                this.isOperationDisabled = false;
                this.showSideBar = false;
                break;
            }
            break;
          case 'MonitorOperation':
            switch (event.name) {
              case 'init':
                this.isLoading = true;
                break;
              case 'completed':
                this.monitorType = event.data;
                this.tempTypeValue = this.monitorType;
                this.isLoading = false;
                break;
              case 'failed':
                this.isLoading = false;
                this.monitorType = this.tempTypeValue;
                break;
            }
            break;
          case 'Call':
            switch (event.name) {
              case 'mute':
                this.isMuted = !this.isMuted;
                break;
            }
            break;
        }
      })
    );
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  isLoading: boolean = false;
  isMonitoring: boolean = false;
  viewType = 'list';
  call: any;
  supervisorCallSid = '';
  activeMonitoringSid = '';
  isMuted: boolean = false;
  showSideBar: boolean = false;
  monitorType = 'observe';
  tempTypeValue = 'observe';
  isOperationDisabled = false;
  isRefresh: boolean = false;
  getCallMonitorData(
    from: string,
    to: string,
    CampaignId: string,
    limit: Number,
    Skip: Number,
    field: string,
    fieldValue: string,
    criteria: string
  ) {
    const url = `/calls/callMonitoring?From=${from}&To=${to}&CampaignId=${CampaignId}&Field=${field}&FieldValue=${fieldValue}&Criteria=${criteria}&Limit=${limit}&Skip=${Skip}`;
    return this.httpClient.disableLoader().get(url);
  }
  toggleView(type: string) {
    this.viewType = type;
  }
  startCallMonitoring(callSid: string) {
    if (this.isLoading) return;
    if (!this.isActive(callSid) && !this.activeMonitoringSid) {
      this.telephony.voice.monitorCall(null, callSid);
    } else {
      this.stopCallMonitoring(callSid);
    }
  }
  stopCallMonitoring(callSid: string) {
    if (this.isActive(callSid)) {
      this.telephony.voice.stopMonitorCall(null);
      this.showSideBar = false;
      this.monitorType = 'observe';
    }
  }
  isActive(callSid: string) {
    if (this.isMonitoring == true && this.activeMonitoringSid == callSid) {
      return true;
    } else return false;
  }
  muteUnMuteCall() {
    this.telephony.voice.muteUnMuteCall(null);
  }

  toggleSideBar(value: boolean) {
    this.showSideBar = value;
  }
  selectCall(call: any) {
    this.call = call;
    this.showSideBar = true;
    this.startCallMonitoring(call.CallSid);
  }
  getConnectedCallDetails(callSid: string) {
    const url = `/calls/connected?CallSid=${callSid}`;
    return this.httpClient.disableLoader().get(url);
  }
  toggleMonitorType(event: any, callSid: string) {
    const type = event.target.value;
    this.telephony.voice.callMonitorOperation(null, callSid, type);
  }
}
